import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const TradingIcon = observer(
    'TradingIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M3.5 3.5v21h21m-9.333-4.667V10.5M21 19.833v-14m-11.667 14v-3.5'
            />
        </SvgElement>
    )
);
